<ng-container *ngIf="enableDataTableAccessibility$ | async; else oldTemplate">
<div id="filterBox" class="filter-box">
    <div class="modal-header">
      <h5>{{ filterCol?.name | titlecase }}</h5>
    </div>
    <div class="modal-body d-flex align-items-center" *ngIf="filterCol">
      <!-- ENUM or ENUM2 Field -->
      <div
        class="select2-form-group w-100"
        *ngIf="filterCol?.fieldType === 'ENUM' || filterCol?.fieldType === 'ENUM2'"
      >
        <app-sr-only>
          <label [attr.for]="'enum-select-' + filterCol.fieldName">
            Filter values for {{ filterCol.name }}
          </label>
        </app-sr-only>
        <ng-select
          [attr.id]="'enum-select-' + filterCol.fieldName"
          bindLabel="label"
          bindValue="value"
          [items]="filterCol?.dropdownValues"
          [(ngModel)]="filterCol.filterValue"
          [multiple]="true"
          appendTo="body"
          placeholder="-- Select --"
          [closeOnSelect]="false"
          [attr.aria-label]="'Filter values for ' + filterCol.name"
          [attr.aria-required]="false"
          [attr.aria-multiselectable]="true"
        >
          <ng-template ng-option-tmp let-item="item">
            {{ item.label }}
          </ng-template>
        </ng-select>
      </div>

      <!-- USER or Relation Field -->
      <div
        class="select2-form-group w-100"
        *ngIf="filterCol?.fieldType === 'USER' || filterCol?.isRelation"
      >
        <app-select-search-scroll
          [options]="[]"
          [minSearchLength]="3"
          [searchable]="true"
          [scrollable]="true"
          class="w-100"
          (selected)="selectScrollValues($event, filterCol)"
          [isConditionComponent]="!(filterCol.isRelation || loadExternalUsers)"
          [isSubscriptionComponent]="loadExternalUsers"
          [isRelatedDataComponent]="filterCol.isRelation"
          [selectedValue]="filterCol.filterValue"
          [passedTableKey]="tableId"
          [dropdownFieldKey]="filterCol.isRelation ? filterCol.proxyFieldKey : ''"
          [dropdownType]="filterCol.proxyFieldType"
          [multiple]="true"
          [closeOnSelect]="false"
          [isSelectDisabled]="true"
          [fetchFromServer]="filterCol.isRelation"
          [relatedFieldKey]="filterCol.fieldKey"
          [label]="'Filter values'"
          [accessibleLabel]="'Filter values for ' + filterCol.name"
        ></app-select-search-scroll>
      </div>

      <!-- DATE or DATETIME Field -->
      <div
        class="select2-form-group w-100"
        *ngIf="filterCol?.fieldType === 'DATE' || filterCol?.fieldType === 'DATETIME' || datecreatedRegex.test(filterCol.fieldName) || datemodifiedRegex.test(filterCol.fieldName)"
      >
        <div class="row">
          <ng-select
            class="col mb-3"
            bindLabel="label"
            bindValue="value"
            [items]="dateOptions"
            [(ngModel)]="filterCol.filterCondition"
            [searchable]="false"
            [clearable]="false"
            placeholder="-- Select Condition --"
            [attr.aria-label]="'Filter values for ' + filterCol.name"
          >
          </ng-select>
        </div>
        <div class="row" *ngIf="filterCol.filterCondition !== 'today'">
          <div class="form-group-control col d-flex">
            <app-sr-only>
              <label [attr.for]="'date-filter-start-' + filterCol.fieldName">
                Start date for {{ filterCol.name }}
              </label>
            </app-sr-only>
            <input
              *ngIf="filterCol.filterCondition !== 'year'"
              [attr.id]="'date-filter-start-' + filterCol.fieldName"
              [type]="getDateInputType(filterCol)"
              class="form-control filter-value-input"
              [min]="getMinValue(getDateInputType(filterCol))"
              [max]="getMaxValue(getDateInputType(filterCol))"
              [(ngModel)]="filterCol.filterValue"
              [attr.aria-label]="'Start date for ' + filterCol.name"
              [attr.aria-required]="true"
            />
            <app-sr-only>
              <label [attr.for]="'year-filter-' + filterCol.fieldName">
                Year for {{ filterCol.name }}
              </label>
            </app-sr-only>
            <input
              *ngIf="filterCol.filterCondition === 'year'"
              [attr.id]="'year-filter-' + filterCol.fieldName"
              type="number"
              class="form-control filter-value-input"
              [min]="1990"
              [max]="2100"
              [maxLength]="4"
              [minLength]="4"
              [value]="filterCol.filterValue"
              (keyup)="setValue($event)"
              [attr.aria-label]="'Year for ' + filterCol.name"
              placeholder="YYYY"
              [attr.aria-required]="true"
            />
          </div>
          <div
            class="form-group-control col d-flex"
            *ngIf="filterCol.filterCondition === 'not_between_date' || filterCol.filterCondition === 'between_date'"
          >
            <app-sr-only>
              <label [attr.for]="'date-filter-end-' + filterCol.fieldName">
                End date for {{ filterCol.name }}
              </label>
            </app-sr-only>
            <input
              [attr.id]="'date-filter-end-' + filterCol.fieldName"
              [type]="getDateInputType(filterCol)"
              class="form-control filter-value-input"
              [min]="getMinValue(getDateInputType(filterCol))"
              [max]="getMaxValue(getDateInputType(filterCol))"
              [(ngModel)]="filterCol.filterValue2"
              [attr.aria-label]="'End date for ' + filterCol.name"
              [attr.aria-required]="true"
            />
          </div>
        </div>
      </div>

      <!-- INT, DECIMAL, or DOUBLE Field -->
      <div
        class="select2-form-group w-100"
        *ngIf="(filterCol?.fieldType === 'INT' && !filterCol.isRelation && !datecreatedRegex.test(filterCol.fieldName) && !datemodifiedRegex.test(filterCol.fieldName)) || filterCol?.fieldType === 'DECIMAL(20,2)' || filterCol?.fieldType === 'DOUBLE'"
      >
        <div class="row">
          <div class="form-group-control col d-flex">
            <app-slider
              [min]="filterCol.minValue"
              [max]="filterCol.maxValue"
              [minSelectedValue]="filterCol.filterValue"
              [maxSelectedValue]="filterCol.filterValue2"
              (sliderValueChanges)="onSliderValueChange($event)"
            ></app-slider>
          </div>
        </div>
      </div>

      <!-- TINYINT(1) Field -->
      <div
        class="select2-form-group w-100"
        *ngIf="filterCol?.fieldType === 'TINYINT(1)'"
      >
        <div class="row ml-3">
          <div class="custom-control col custom-checkbox">
            <label [attr.for]="'checkbox-true-' + filterCol.fieldName">
              <input
                [attr.id]="'checkbox-true-' + filterCol.fieldName"
                type="checkbox"
                (change)="changeCheckboxValue($event, true)"
                [checked]="filterCol.filterValue"
                [attr.aria-label]="'Filter for true values in ' + filterCol.name"
              />
              &nbsp;&nbsp;True
            </label>
          </div>
          <div class="custom-control col custom-checkbox">
            <label [attr.for]="'checkbox-false-' + filterCol.fieldName">
              <input
                [attr.id]="'checkbox-false-' + filterCol.fieldName"
                type="checkbox"
                (change)="changeCheckboxValue($event)"
                [checked]="filterCol.filterValue2"
                [attr.aria-label]="'Filter for false values in ' + filterCol.name"
              />
              &nbsp;&nbsp;False
            </label>
          </div>
        </div>
      </div>

      <!-- String or Other Fields -->
      <div
        class="select2-form-group w-100"
        *ngIf="!isStringField(filterCol)"
      >
        <div class="row">
          <ng-select
            class="col mb-3"
            bindLabel="label"
            bindValue="value"
            [items]="(allowColumnFilter && filterCol.fieldName === 'refreshtokentime') ? integerOptions : stringOptions"
            [(ngModel)]="filterCol.filterCondition"
            [searchable]="false"
            [clearable]="false"
            placeholder="-- Select Condition --"
            [attr.aria-label]="'Filter values for ' + filterCol.name"
          >
          </ng-select>
        </div>
        <div class="row" *ngIf="filterCol.filterCondition !== 'empty'">
          <div class="col">
            <app-sr-only>
              <label [attr.for]="'filter-value-' + filterCol.fieldName">
                Filter value for {{ filterCol.name }}
              </label>
            </app-sr-only>
            <input
              [attr.id]="'filter-value-' + filterCol.fieldName"
              class="form-control filter-value-input"
              placeholder="Enter Value"
              [(ngModel)]="filterCol.filterValue"
              (keyup)="setValue($event)"
              [type]="(allowColumnFilter && filterCol.fieldName === 'refreshtokentime') ? 'number' : 'text'"
              [attr.aria-label]="'Enter filter value for ' + filterCol.name"
              [attr.aria-required]="filterCol.filterCondition !== 'empty'"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <app-modal-action-btns
        (onReject)="clearFilterForCol(filterCol)"
        (onConfirm)="selectFilterSelected(filterCol)"
        confirmTitle="Apply"
        rejectTitle="Clear"
        [disabled]="isFilterApplyDisabled(filterCol)"
        [useFormSubmit]="false"
        class="custom-position"
      ></app-modal-action-btns>
    </div>
  </div>
</ng-container>

<ng-template #oldTemplate>
<div id="filterBox" class="filter-box">
    <div class="modal-header">
      <h5>{{ filterCol?.name | titlecase }}</h5>
    </div>
    <div class="modal-body d-flex align-items-center" *ngIf="filterCol">
      <!-- ENUM or ENUM2 Field -->
      <div
        class="select2-form-group w-100"
        *ngIf="filterCol?.fieldType === 'ENUM' || filterCol?.fieldType === 'ENUM2'"
      >
        <app-sr-only>
          <label [attr.for]="'enum-select-' + filterCol.fieldName">
            Filter values for {{ filterCol.name }}
          </label>
        </app-sr-only>
        <ng-select
          [attr.id]="'enum-select-' + filterCol.fieldName"
          bindLabel="label"
          bindValue="value"
          [items]="filterCol?.dropdownValues"
          [(ngModel)]="filterCol.filterValue"
          [multiple]="true"
          appendTo="body"
          placeholder="-- Select --"
          [closeOnSelect]="false"
          [attr.aria-label]="'Filter values for ' + filterCol.name"
          [attr.aria-required]="false"
          [attr.aria-multiselectable]="true"
        >
          <ng-template ng-option-tmp let-item="item">
            {{ item.label }}
          </ng-template>
        </ng-select>
      </div>

      <!-- USER or Relation Field -->
      <div
        class="select2-form-group w-100"
        *ngIf="filterCol?.fieldType === 'USER' || filterCol?.isRelation"
      >
        <app-select-search-scroll
          [options]="[]"
          [minSearchLength]="3"
          [searchable]="true"
          [scrollable]="true"
          class="w-100"
          (selected)="selectScrollValues($event, filterCol)"
          [isConditionComponent]="!(filterCol.isRelation || loadExternalUsers)"
          [isSubscriptionComponent]="loadExternalUsers"
          [isRelatedDataComponent]="filterCol.isRelation"
          [selectedValue]="filterCol.filterValue"
          [passedTableKey]="tableId"
          [dropdownFieldKey]="filterCol.isRelation ? filterCol.proxyFieldKey : ''"
          [dropdownType]="filterCol.proxyFieldType"
          [multiple]="true"
          [closeOnSelect]="false"
          [isSelectDisabled]="true"
          [fetchFromServer]="filterCol.isRelation"
          [relatedFieldKey]="filterCol.fieldKey"
          [label]="'Filter values'"
          [accessibleLabel]="'Filter values for ' + filterCol.name"
        ></app-select-search-scroll>
      </div>

      <!-- DATE or DATETIME Field -->
      <div
        class="select2-form-group w-100"
        *ngIf="filterCol?.fieldType === 'DATE' || filterCol?.fieldType === 'DATETIME' || datecreatedRegex.test(filterCol.fieldName) || datemodifiedRegex.test(filterCol.fieldName)"
      >
        <div class="row">
          <ng-select
            class="col mb-3"
            bindLabel="label"
            bindValue="value"
            [items]="dateOptions"
            [(ngModel)]="filterCol.filterCondition"
            [searchable]="false"
            [clearable]="false"
            placeholder="-- Select Condition --"
            [attr.aria-label]="'Filter values for ' + filterCol.name"
          >
          </ng-select>
        </div>
        <div class="row" *ngIf="filterCol.filterCondition !== 'today'">
          <div class="form-group-control col d-flex">
            <app-sr-only>
              <label [attr.for]="'date-filter-start-' + filterCol.fieldName">
                Start date for {{ filterCol.name }}
              </label>
            </app-sr-only>
            <input
              *ngIf="filterCol.filterCondition !== 'year'"
              [attr.id]="'date-filter-start-' + filterCol.fieldName"
              [type]="getDateInputType(filterCol)"
              class="form-control filter-value-input"
              [min]="getMinValue(getDateInputType(filterCol))"
              [max]="getMaxValue(getDateInputType(filterCol))"
              [(ngModel)]="filterCol.filterValue"
              [attr.aria-label]="'Start date for ' + filterCol.name"
              [attr.aria-required]="true"
            />
            <app-sr-only>
              <label [attr.for]="'year-filter-' + filterCol.fieldName">
                Year for {{ filterCol.name }}
              </label>
            </app-sr-only>
            <input
              *ngIf="filterCol.filterCondition === 'year'"
              [attr.id]="'year-filter-' + filterCol.fieldName"
              type="number"
              class="form-control filter-value-input"
              [min]="1990"
              [max]="2100"
              [maxLength]="4"
              [minLength]="4"
              [value]="filterCol.filterValue"
              (keyup)="setValue($event)"
              [attr.aria-label]="'Year for ' + filterCol.name"
              placeholder="YYYY"
              [attr.aria-required]="true"
            />
          </div>
          <div
            class="form-group-control col d-flex"
            *ngIf="filterCol.filterCondition === 'not_between_date' || filterCol.filterCondition === 'between_date'"
          >
            <app-sr-only>
              <label [attr.for]="'date-filter-end-' + filterCol.fieldName">
                End date for {{ filterCol.name }}
              </label>
            </app-sr-only>
            <input
              [attr.id]="'date-filter-end-' + filterCol.fieldName"
              [type]="getDateInputType(filterCol)"
              class="form-control filter-value-input"
              [min]="getMinValue(getDateInputType(filterCol))"
              [max]="getMaxValue(getDateInputType(filterCol))"
              [(ngModel)]="filterCol.filterValue2"
              [attr.aria-label]="'End date for ' + filterCol.name"
              [attr.aria-required]="true"
            />
          </div>
        </div>
      </div>

      <!-- INT, DECIMAL, or DOUBLE Field -->
      <div
        class="select2-form-group w-100"
        *ngIf="(filterCol?.fieldType === 'INT' && !filterCol.isRelation && !datecreatedRegex.test(filterCol.fieldName) && !datemodifiedRegex.test(filterCol.fieldName)) || filterCol?.fieldType === 'DECIMAL(20,2)' || filterCol?.fieldType === 'DOUBLE'"
      >
        <div class="row">
          <div class="form-group-control col d-flex">
            <app-slider
              [min]="filterCol.minValue"
              [max]="filterCol.maxValue"
              [minSelectedValue]="filterCol.filterValue"
              [maxSelectedValue]="filterCol.filterValue2"
              (sliderValueChanges)="onSliderValueChange($event)"
            ></app-slider>
          </div>
        </div>
      </div>

      <!-- TINYINT(1) Field -->
      <div
        class="select2-form-group w-100"
        *ngIf="filterCol?.fieldType === 'TINYINT(1)'"
      >
        <div class="row ml-3">
          <div class="custom-control col custom-checkbox">
            <label [attr.for]="'checkbox-true-' + filterCol.fieldName">
              <input
                [attr.id]="'checkbox-true-' + filterCol.fieldName"
                type="checkbox"
                (change)="changeCheckboxValue($event, true)"
                [checked]="filterCol.filterValue"
                [attr.aria-label]="'Filter for true values in ' + filterCol.name"
              />
              &nbsp;&nbsp;True
            </label>
          </div>
          <div class="custom-control col custom-checkbox">
            <label [attr.for]="'checkbox-false-' + filterCol.fieldName">
              <input
                [attr.id]="'checkbox-false-' + filterCol.fieldName"
                type="checkbox"
                (change)="changeCheckboxValue($event)"
                [checked]="filterCol.filterValue2"
                [attr.aria-label]="'Filter for false values in ' + filterCol.name"
              />
              &nbsp;&nbsp;False
            </label>
          </div>
        </div>
      </div>

      <!-- String or Other Fields -->
      <div
        class="select2-form-group w-100"
        *ngIf="!isStringField(filterCol)"
      >
        <div class="row">
          <ng-select
            class="col mb-3"
            bindLabel="label"
            bindValue="value"
            [items]="(allowColumnFilter && filterCol.fieldName === 'refreshtokentime') ? integerOptions : stringOptions"
            [(ngModel)]="filterCol.filterCondition"
            [searchable]="false"
            [clearable]="false"
            placeholder="-- Select Condition --"
            [attr.aria-label]="'Filter values for ' + filterCol.name"
          >
          </ng-select>
        </div>
        <div class="row" *ngIf="filterCol.filterCondition !== 'empty'">
          <div class="col">
            <app-sr-only>
              <label [attr.for]="'filter-value-' + filterCol.fieldName">
                Filter value for {{ filterCol.name }}
              </label>
            </app-sr-only>
            <input
              [attr.id]="'filter-value-' + filterCol.fieldName"
              class="form-control filter-value-input"
              placeholder="Enter Value"
              [(ngModel)]="filterCol.filterValue"
              (keyup)="setValue($event)"
              [type]="(allowColumnFilter && filterCol.fieldName === 'refreshtokentime') ? 'number' : 'text'"
              [attr.aria-label]="'Enter filter value for ' + filterCol.name"
              [attr.aria-required]="filterCol.filterCondition !== 'empty'"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <app-modal-action-btns
        (onReject)="clearFilterForCol(filterCol)"
        (onConfirm)="selectFilterSelected(filterCol)"
        confirmTitle="Apply"
        rejectTitle="Clear"
        [disabled]="isFilterApplyDisabled(filterCol)"
        [useFormSubmit]="false"
        class="custom-position"
      ></app-modal-action-btns>
    </div>
  </div></ng-template>
